import Memory from "dojo/store/Memory";
import locale from "csi/locale";

interface FusionStoreItem {
	cssClass: string;
	id: string;
	multiseries?: boolean;
	name?: string;
	oldId: string;
	percentages?: boolean;
	stackedType?: boolean;
	template: object;
}

// default template for all charts
const template = {
	_type: "object",
	chart: {
		bgColor: "FFFFFF",
		showBorder: "0",
	},
};

const store = new Memory<FusionStoreItem>({
	idProperty: "id",
	data: [
		{
			id: "Area2D",
			oldId: "Area",
			cssClass: "csi-icon-chart-area",
			template,
		},
		{
			id: "Bar2D",
			oldId: "Bar",
			cssClass: "csi-icon-chart-bar",
			template,
		},
		{
			id: "Column2D",
			oldId: "Column 2D",
			cssClass: "csi-icon-chart-column",
			template,
		},
		{
			id: "Line",
			oldId: "Line",
			cssClass: "csi-icon-chart-line",
			template,
		},
		{
			id: "Doughnut2D",
			oldId: "Doughnut 2D",
			cssClass: "csi-icon-chart-doughnut",
			percentages: true,
			template,
		},
		{
			id: "MSArea",
			oldId: "Multi-series Area",
			cssClass: "csi-icon-chart-ms-area",
			multiseries: true,
			template,
		},
		{
			id: "MSBar2D",
			oldId: "Multi-series Bar 2D",
			cssClass: "csi-icon-chart-ms-bar",
			multiseries: true,
			template,
		},
		{
			id: "MSColumn2D",
			oldId: "Multi-series Column 2D",
			cssClass: "csi-icon-chart-ms-column",
			multiseries: true,
			template,
		},
		{
			id: "MSLine",
			oldId: "Multi-series Line",
			cssClass: "csi-icon-chart-ms-line",
			multiseries: true,
			template,
		},
		{
			id: "Pie2D",
			oldId: "Pie 2D",
			cssClass: "csi-icon-chart-pie",
			percentages: true,
			template,
		},
		{
			id: "StackedArea2D",
			oldId: "Stacked Area",
			cssClass: "csi-icon-chart-stacked-area",
			multiseries: true,
			percentages: true,
			stackedType: true,
			template,
		},
		{
			id: "StackedBar2D",
			oldId: "Stacked Bar 2D",
			cssClass: "csi-icon-chart-stacked-bar",
			multiseries: true,
			percentages: true,
			stackedType: true,
			template,
		},
		{
			id: "StackedColumn2D",
			oldId: "Stacked Column 2D",
			cssClass: "csi-icon-chart-stacked-column",
			multiseries: true,
			percentages: true,
			stackedType: true,
			template,
		},
		{
			id: "Pareto2D",
			oldId: "Pareto 2D",
			cssClass: "csi-icon-chart-pareto",
			template,
		},
	],
});

// avoid type checking since labelProperty is not property of Memory store
store["labelProperty"] = "name";

// fill in localized names of store items
locale.deferred.then(() => {
	const prefix = "ChartType_";

	store.query({}).forEach((item: FusionStoreItem) => {
		item.name = locale.resource(prefix + item.id);
	});
});

export = store;
